var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagem(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.4,4.7H6.6c-1.4,0-2.5,1.1-2.5,2.4v10.4c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.1,0.4,0.3,0.6 c0.4,0.7,1.2,1.2,2.1,1.2h11.9c0.9,0,1.7-0.5,2.1-1.2c0.1-0.2,0.2-0.5,0.3-0.8c0-0.1,0-0.3,0-0.4V10h0c0-0.3-0.3-0.6-0.6-0.6 c-0.3,0-0.6,0.3-0.6,0.6h0v5.5L17,12.4c-0.3-0.4-0.8-0.6-1.3-0.6c-0.5,0-0.9,0.2-1.2,0.5l-0.4,0.3c-0.7-0.8-1.6-1.9-1.8-2.1 c-0.5-0.7-1-0.8-1.4-0.8c-0.6,0-1.1,0.3-1.5,0.8l-4,5.1V7.1c0-0.7,0.6-1.2,1.2-1.2h11.9c0.7,0,1.2,0.5,1.2,1.2v0.2h0 c0,0.3,0.3,0.5,0.6,0.5c0.3,0,0.6-0.2,0.6-0.5h0V7.1C20.9,5.8,19.8,4.7,18.4,4.7 M10.3,11.1c0.2-0.2,0.4-0.3,0.5-0.3 c0.2,0,0.4,0.2,0.5,0.3c0.3,0.4,1.8,2.1,1.9,2.3l0,0c0.5,0.5,1,0.5,1.5,0l0.4-0.4l0,0c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.3,0,0.4,0.2 l3.6,4.1v0.2c0,0.7-0.6,1.2-1.2,1.2H6.6c-0.7,0-1.2-0.5-1.2-1.2v-0.1L10.3,11.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagem);
export default __webpack_public_path__ + "static/media/imagem.2c2378899fa0be2ef69cc27b117c4d05.svg";
export { ForwardRef as ReactComponent };